module.exports = __webpack_public_path__ + "static/media/es-ga.a13fb06a.svg";